// These are completed, backend-validated answers, never provider token deltas.
export function createValidatedTextReveal(text, onText) {
  const full = String(text || "");
  const firstBoundary = full.match(/[.!?](?:\s+|$)/);
  let visible = firstBoundary ? firstBoundary.index + firstBoundary[0].length : full.length;
  const size = Math.max(160, Math.ceil((full.length - visible) / 20));
  let timer = null;
  let cancelled = false;
  onText(full.slice(0, visible));
  const finish = () => {
    clearTimeout(timer);
    if (!cancelled) onText(full);
    cancelled = true;
  };
  const step = () => {
    if (cancelled) return;
    // At most twenty short display updates, preserving the exact written text.
    const end = Math.min(full.length, visible + size);
    const boundary = full.indexOf(" ", end);
    visible = boundary < 0 ? full.length : boundary + 1;
    onText(full.slice(0, visible));
    if (visible === full.length) finish();
    else timer = setTimeout(step, 120);
  };
  return {
    start() { if (!cancelled) { clearTimeout(timer); timer = setTimeout(step, 120); } },
    finish,
    dispose() { cancelled = true; clearTimeout(timer); },
  };
}

export function recordVibeBeeTiming(name, started, surface) {
  try {
    const end = performance.now();
    performance.measure(`vibebee.${name}`, { start: started, end, detail: { surface } });
    // Bound content-free, browser-local diagnostics; no new network telemetry.
    const entries = performance.getEntriesByName(`vibebee.${name}`);
    if (entries.length > 20) performance.clearMeasures(`vibebee.${name}`);
    return end - started;
  } catch (_) { return null; }
}
